import {API} from './api'
import {METHOD, request} from '@/utils/request'
import download from './downloadFile'


/**
 * 查询批次数据
 * @param {*} params 
 * @returns 
 */
export function queryAll (params){
    return request(API+'/leavingschool/graduationBatch/queryAll', METHOD.GET, params)
}


/**
 * 更新批次状态
 * @param {*} params 
 * @returns 
 */
export function updateStatus(params){
    return request(API+'/leavingschool/graduationBatch/updateStatus', METHOD.POST, params)
}


/**
 * 删除毕业名单
 * @param {*} params 
 * @returns 
 */
export function del(params){
    return request(API+'/leavingschool/graduationBatch/deleteBatch', METHOD.DELETE, params)
}


/**
 * 错误学生数据下载
 * @param {*} params 
 * @returns 
 */
export function downStudentError(str){
    // window.location.href = API+'/leavingschool/graduationStudent/downStudentError'+str
    download(API+'/leavingschool/graduationStudent/downStudentError'+str, null, ' 错误名单数据.xlsx')
}

/**
 * 批次学生数据下载
 * @param {*} params 
 * @returns 
 */
export function downStudentByBatchId(str){
    // window.location.href = API+'/leavingschool/graduationStudent/downStudentByBatchId'+str
    download(API+'/leavingschool/graduationStudent/downStudentByBatchId'+str, null, '名单数据.xlsx')
}

/**
 * 毕业名单导入
 * @param {*} data 
 * @returns 
 */
export function importStudent(data){
    return request(API+'/leavingschool/graduationBatch/importStudent', METHOD.POST, data)
}

/**
 * 毕业名单数据更新
 * @param {*} data
 * @returns
 */
export function asyncStudent(data){
    return request(API+'/leavingschool/graduationBatch/asyncStudent', METHOD.POST, data)
}

/**
 * 毕业名单新增学生数据导入
 * @param {*} data 
 * @returns 
 */
export function addStudent(data){
    return request(API+'/leavingschool/graduationBatch/addStudent', METHOD.POST, data)
}

/**
 * 毕业名单更新学生数据导入
 * @param {*} data 
 * @returns 
 */
export function updateStudent(data){
    return request(API+'/leavingschool/graduationBatch/updateStudent', METHOD.POST, data)
}

/**
 * 根据批次查询学生信息
 * @param {*} params 
 * @returns 
 */
export function queryStudentByBatchId(params){
    return request(API+'/leavingschool/graduationStudent/queryStudentByBatchId', METHOD.GET, params)
}

/**
 * 逻辑删除学生
 * @param {*} params 
 * @returns 
 */
export function deleteStudent(params){
    return request(API+'/leavingschool/graduationStudent/deleteStudent', METHOD.DELETE, params)
}


/**
 * 毕业批次列表
 * @returns 
 */
 export function listGraduationBatch(){
    return request(API + '/leavingschool/graduationBatch/getBatchDic', METHOD.GET)
}

/**
 * 上传删除学生名单
 * @param {*} data 
 * @returns 
 */
export function uploadDelStudent(data){
    return request(API+'/leavingschool/graduationStudent/uploadDelStudent', METHOD.POST, data)
}

/**
 * 上传保留学生名单
 * @param {*} data 
 * @returns 
 */
 export function uploadSaveStudent(data){
    return request(API+'/leavingschool/graduationStudent/uploadStudent', METHOD.POST, data)
}